import api from "../api/persons";
import {getPerson, getPersonRoles, getSystemInfo} from "./actions";
import {createError, logError, logSuccess} from "../../../../ui/Notify";
import types from "./types";


function importPersonsRequest() {
  return {
    type: types.IMPORT_PERSONS_REQUEST,
    isImportingPersons: true
  };
}

function importPersonsCompleted(importedPersons) {
  return {
    type: types.IMPORT_PERSONS_COMPLETED,
    isImportingPersons: false,
    importedPersons
  };
}

function importPersonsError (importPersonsError){
  return {
    type: types.IMPORT_PERSONS_ERROR,
    isImportingPersons: false,
    importPersonsError
  };
}

function createPersonRequest() {
  return {
    type: types.CREATE_PERSON_REQUEST,
    isCreatingPerson: true
  };
}

function createPersonCompleted(createdPerson) {
  return {
    type: types.CREATE_PERSON_COMPLETED,
    isCreatingPerson: false,
    createdPerson
  };
}

function createPersonError(personCreationError) {
  return {
    type: types.CREATE_PERSON_ERROR,
    isCreatingPerson: false,
    personCreationError
  };
}

function blockPersonRequest() {
  return {
    type: types.BLOCK_PERSON_REQUEST,
    isBlockingPerson: true
  };
}

function blockPersonCompleted(blockedPerson) {
  return {
    type: types.BLOCK_PERSON_COMPLETED,
    isBlockingPerson: false,
    blockedPerson
  };
}

function blockPersonError(personBlockError) {
  return {
    type: types.BLOCK_PERSON_ERROR,
    isBlockingPerson: false,
    personBlockError
  };
}

function updatePersonRequest() {
  return {
    type: types.UPDATE_PERSON_REQUEST,
    isUpdatingPerson: true
  };
}

function updatePersonCompleted(updatedPerson) {
  return {
    type: types.UPDATE_PERSON_COMPLETED,
    isUpdatingPerson: false,
    updatedPerson
  };
}

function updatePersonError(personUpdateError) {
  return {
    type: types.UPDATE_PERSON_ERROR,
    isUpdatingPerson: false,
    personUpdateError
  };
}

function updatePersonRolesRequest() {
  return {
    type: types.UPDATE_PERSON_ROLES_REQUEST,
    isUpdatingRoles: true
  };
}

function updatePersonRolesCompleted(updatedRoles) {
  return {
    type: types.UPDATE_PERSON_ROLES_COMPLETED,
    isUpdatingRoles: false,
    updatedRoles
  };
}

function updatePersonRolesError(rolesUpdateError) {
  return {
    type: types.UPDATE_PERSON_ROLES_ERROR,
    isUpdatingRoles: false,
    rolesUpdateError
  };
}

function addAttachmentsCompleted(attachments) {
  return {
    type: types.ADD_ATTACHMENTS_COMPLETED,
    attachments
  };
}

function addAttachmentsError(attachError) {
  return {
    type: types.ADD_ATTACHMENTS_ERROR,
    attachError
  };
}

function addAttachmentsSnilsCompleted(attachmentsSnils) {
  return {
    type: types.ADD_ATTACHMENTS_SNILS_COMPLETED,
    attachmentsSnils
  };
}

function addAttachmentsSnilsError(attachError) {
  return {
    type: types.ADD_ATTACHMENTS_SNILS_ERROR,
    attachError
  };
}

function updateAvatarRequest() {
  return {
    type: types.UPDATE_PERSON_AVATAR_REQUEST,
    isUpdatingAvatar: true
  };
}

function updateAvatarCompleted(updatedAvatar) {
  return {
    type: types.UPDATE_PERSON_AVATAR_COMPLETED,
    isUpdatingAvatar: false,
    updatedAvatar
  };
}

function updateAvatarError(avatarUpdateError) {
  return {
    type: types.UPDATE_PERSON_AVATAR_ERROR,
    isUpdatingAvatar: false,
    avatarUpdateError
  };
}

export function createPerson(data) {
  return dispatch => {
    dispatch(createPersonRequest());
    return api
      .createPerson(data)
      .then(response => {
        if (response.status === 200) {
          dispatch(createPersonCompleted(response.data));
          logSuccess("Профиль сотрудника успешно создан")
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(createPersonError(message));
        } else {
          logError(err);
          dispatch(createPersonError(createError("Не удалось отправить запрос добавления сотрудника")));
        }
      });
  };
}

export function blockPerson(id, type) {
  return dispatch => {
    dispatch(blockPersonRequest());
    return api.blockPerson(id, type).then(response => {
        if (response.status === 200) {
          if (type === "block") {logSuccess("Учетная запись сотрудника заблокирована");}
          else if (type === "unblock") {logSuccess("Учетная запись сотрудника разблокирована");}
          dispatch(blockPersonCompleted(response.data));
          dispatch(getSystemInfo(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(blockPersonError(message));
        } else {
          logError(err);
          dispatch(blockPersonError(createError("Не удалось отправить запрос")));
        }
      });
  };
}

function packFileAsync(file) {
    const reader = new FileReader();
    return new Promise((resolve, reject) => {
        reader.onerror = () => {
            reader.abort();
            reject(new Error("Error parsing file"));
        };
        reader.onload = function () {
            let bytes = Array.from(new Uint8Array(this.result));
            let base64StringFile = btoa(bytes.map((item) => String.fromCharCode(item)).join(""));
            resolve({
                fileContent: base64StringFile,
                fileName: file.name,
                fileType: file.type
            });
        };
        reader.readAsArrayBuffer(file);
    });
}

export function importPersons(data) {
   return dispatch => {
     dispatch(importPersonsRequest());

     packFileAsync(data.file).then(packed => {
        const importData = {
          orgId : data.orgId,
          depId : data.depId,
          csv: packed.fileContent,
          type : "import",
          encoding : "UTF-8"
        };

        return api.importPersons(importData).then(response => {
            if (response.status === 200) {
              dispatch(importPersonsCompleted(response.data));
            } else {
              return Promise.reject(response);
            }
            return Promise.resolve();
          }).catch(err => {
            if (err.response && err.response.status === 400) {
              let message = err.response;
              if (err.response.data && err.response.data.errors) {
                message = err.response.data.errors.map(({ message }) => message).join(", ");
              }

              logError(message);
              dispatch(importPersonsError(message));
            } else {
              logError(err);
              dispatch(importPersonsError(createError("Не удалось импортировать список сотрудников")));
            }
          });
      }).catch(err => {
            logError(err);
            dispatch(importPersonsError(createError("Не удалось загрузить файл")));
        });
    };
}


export function addAttachments(attachments) {
  return async (dispatch, getState) => {
    const id = getState().persons.personFullInfo.info.id;
    const response = await Promise.all(
      attachments.map(attach => api.addPersonAttachment(id, attach))
    );

    if (response.every(({ data }) => data.success === true)) {
      dispatch(addAttachmentsCompleted(response));
      dispatch(getPerson(id));
    } else {
      dispatch(addAttachmentsError(response));
    }
    return response;
  };
}

export function addAttachmentsSnils(attachments) {
  return async (dispatch, getState) => {
    const id = getState().persons.personFullInfo.info.id;
    const response = await Promise.all(
      attachments.map(attach => api.addPersonSnilsAttachment(id, attach))
    );

    if (response.every(({ data }) => data.success === true)) {
      dispatch(addAttachmentsSnilsCompleted(response));
      dispatch(getPerson(id));
    } else {
      dispatch(addAttachmentsSnilsError(response));
    }
    return response;
  };
}

export function updatePerson(id, data) {
  return dispatch => {
    dispatch(updatePersonRequest());
    return api
      .updatePerson(id, data)
      .then(response => {
        if (response.status === 200) {
          logSuccess("Успешно обновлено");
          dispatch(updatePersonCompleted(response.data));
          dispatch(getPerson(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(updatePersonError(message));
        } else {
          logError(err);
          dispatch(updatePersonError(createError("Не удалось отправиь запрос на обновление данных")));
        }
      });
  };
}

export function updatePersonAvatar(id, file) {
  return dispatch => {
    dispatch(updateAvatarRequest());
    return api
      .updateAvatar(id, file)
      .then(response => {
        if (response.status === 200) {
          logSuccess("Успешно обновлено");
          dispatch(updateAvatarCompleted(response.data));
          dispatch(getPerson(id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }

          logError(message);
          dispatch(updateAvatarError(message));
        } else {
          logError(err);
          dispatch(updateAvatarError(createError("Не удалось отправить запрос на обновление аватара")));
        }
      });
  };
}

export function updateRoles(data) {
  return (dispatch, getState) => {
    const id = getState().persons.personFullInfo.info.id;
    const roleIds = data ? data.map((r) => r.id) : [];
    dispatch(updatePersonRolesRequest());
    return api
      .updatePersonRoles(id, roleIds)
      .then(response => {
        if (response.status === 200) {
          logSuccess("Роли пользователя успешно обновлены");
          dispatch(updatePersonRolesCompleted(response.data));
          dispatch(getPersonRoles(getState().persons.personCard.id));
        } else {
          return Promise.reject(response);
        }
        return Promise.resolve();
      })
      .catch(err => {
        if (err.response && err.response.status === 400) {
          let message = err.response;
          if (err.response.data && err.response.data.errors) {
            message = err.response.data.errors.map(({ message }) => message).join(", ");
          }
          logError(message);
          dispatch(updatePersonRolesError(message));
        } else {
          logError(err);
          dispatch(updatePersonRolesError(createError("Не удалось отправиь запрос на обновление ролей")));
        }
      });
  };
}


export default {
  addAttachments,
  addAttachmentsSnils,
  updatePerson,
  updateRoles,
  createPerson,
  importPersons,
  blockPerson,
  updatePersonAvatar
}
